import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import ReportsAPI from '../services/reportsAPI';
import ModernTable from '../components/common/ModernTable';
import styles from './CompletedVoyageReport.module.css';

const CompletedVoyageReport = () => {
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [report, setReport] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    // For Excel download
    const XLSX = require('xlsx');
    const handleDownloadExcel = () => {
        const dataToExport = filteredData.map(row => ({
            'Container Number': row.containerNumber,
            'Vessel Name': row.vesselName,
            'Voyage Number': row.voyageNumber,
            'Milestone Type': row.milestoneType,
            'Actual Date': row.actualDate ? new Date(row.actualDate).toLocaleString() : "",
            'Location': row.location
        }));
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Completed Voyage Report');
        XLSX.writeFile(workbook, 'CompletedVoyageReport.xlsx');
    };

    const fetchReport = async () => {
        setLoading(true);
        setError("");
        ReportsAPI.getCompletedVoyageReport(startDate, endDate)
            .then((res) => {
                setReport(res.data);
                setLoading(false);
            })
            .catch((err) => {
                setError('Failed to fetch completed voyage report');
                setLoading(false);
            });
    };

    // Filter logic
    const filteredData = React.useMemo(() => {
        if (!searchTerm.trim()) return report;
        const lowerSearch = searchTerm.toLowerCase();
        return report.filter(row =>
            (row.containerNumber && row.containerNumber.toLowerCase().includes(lowerSearch)) ||
            (row.vesselName && row.vesselName.toLowerCase().includes(lowerSearch)) ||
            (row.voyageNumber && row.voyageNumber.toLowerCase().includes(lowerSearch)) ||
            (row.milestoneType && row.milestoneType.toLowerCase().includes(lowerSearch)) ||
            (row.location && row.location.toLowerCase().includes(lowerSearch)) ||
            (row.actualDate && new Date(row.actualDate).toLocaleString().toLowerCase().includes(lowerSearch))
        );
    }, [report, searchTerm]);

    // Table columns config
    const columns = [
      { key: 'containerNumber', label: 'Container Number' },
      { key: 'vesselName', label: 'Vessel Name' },
      { key: 'voyageNumber', label: 'Voyage Number' },
      { key: 'milestoneType', label: 'Milestone Type' },
      {
        key: 'actualDate',
        label: 'Actual Date',
        render: (value) => value ? new Date(value).toLocaleDateString() : ''
      },
      { key: 'location', label: 'Location' }
    ];

    return (
        <div className={styles.completedVoyageReport}>
            <button onClick={() => navigate('/agent/dashboard')} className={styles.backButton}>
                &larr; Back to Dashboard
            </button>
            <h2 className={styles.heading}>Completed Voyage Report</h2>
            <div className={styles.dateRow}>
                <label className={styles.dateLabel}>
                    Start Date:
                    <input
                        type="date"
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                        className={styles.dateInput}
                    />
                </label>
                <label className={styles.dateLabel}>
                    End Date:
                    <input
                        type="date"
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                        className={styles.dateInput}
                    />
                </label>
            </div>
            <div className={styles.actionRow}>
                <button onClick={fetchReport} className={"btn btn-sm btn-primary " + styles.fetchButton} disabled={loading}>
                    {loading ? "Loading..." : "Fetch Report"}
                </button>
            </div>
            <div className={styles.searchRow}>
                <input
                    type="text"
                    placeholder="Search by container, vessel, voyage, milestone, location, date..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    className={styles.searchInput}
                />
                <button onClick={handleDownloadExcel} className={"btn btn-sm btn-success " + styles.downloadButton}>
                    Download this report
                </button>
            </div>
            {error && <div style={{ color: "red" }}>{error}</div>}
            <ModernTable columns={columns} data={filteredData} />
        </div>
    );
};

export default CompletedVoyageReport;
